<template>
  <tr :class="computedClasses" :style="isExpired">
    <td v-if="hasCheckbox" style="border-right:1px solid #C4C4C4; padding: 0 10px;">
      <AppCheckbox :checked="isActive"
                   @toggle-check="toggleActive" />
    </td>
    <td v-for="(item, i) in values" :key="i" @click="showItem">{{ (item || '-') | dateFilter }}</td>
    <td class="table__menu-cell" v-if="isMenuControlsActive">
      <div>
        <div class="table__menu" @click.stop="toggleControls">
          <svg class="ellipsis-icon" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2" r="2" fill="currentColor"/>
            <circle cx="11" cy="2" r="2" fill="currentColor"/>
            <circle cx="21" cy="2" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="table__controls">
          <transition name="fade">
            <AppPopupControls v-if="isControlsActive"
                              :active-buttons="{add: menuControls.add, edit: menuControls.update, remove: menuControls.remove}"
                              @edit-this-item="editItem"
                              @remove-this-item="removeItem"
            />
          </transition>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import AppPopupControls from '@/components/page/popup/AppPopupControls.vue'
import AppCheckbox from '@/components/page/input/AppCheckbox'
// import { mapGetters } from 'vuex'

export default {
  name: 'app-table-elem',
  components: {
    AppCheckbox,
    AppPopupControls
  },
  props: {
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isWarning: {
      type: Boolean,
      default: false
    },
    isDeactive: {
      type: Boolean,
      default: false
    },
    isControlsActive: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: [Number, String]
    },
    values: {
      type: Array,
      default: () => []
    },
    isMenuControlsActive: {
      type: Boolean,
      default: true
    },
    menuControls: {
      type: Object,
      default: () => ({
        add: false,
        update: true,
        remove: true
      })
    }
  },
  computed: {
    // ...mapGetters({
    //   currentPage: 'getCurrentPage'
    // }),
    currentUser () {
      return this.$store.getters.currentUser
    },
    computedClasses () {
      return {
        tr_active: this.isActive,
        tr_warning: this.isWarning,
        tr_deactive: this.isDeactive,
        has_checkbox: this.hasCheckbox
      }
    },
    isExpired () {
      const status = this.values.find(item => item === 'ПРОСРОЧЕН' || item === 'Срок истекает')

      if (status && status !== 1) {
        return {
          color: status === 'ПРОСРОЧЕН' ? '#EF424D' : '#FAAB59'
        }
      }

      return {}
    }
  },
  methods: {
    toggleControls () {
      this.$emit('toggle-controls')
    },
    toggleActive () {
      this.$emit('toggle-active', this.itemId)
    },
    editItem () {
      this.$emit('edit-this-item')
    },
    removeItem () {
      this.$emit('remove-this-item')
    },
    showItem () {
      this.$emit('show-this-item')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

@import './_table';

tr {
  cursor: pointer;
}

tr td:nth-child(2) {
  // width: 400px;
}

tr.has_checkbox td:first-child {
  // width: 55px;
}
</style>
